import React, { } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import './styles.scss'
import SidePopup from '../../SidePopupNew'
import { lang } from 'utils/helpers'
import inchatActions from 'redux/inchat/actions'
import Composer from '../Composer'
import MessageThreads from '../ChatMessages/MessageThreads'

const SideView = ({ conversationId, channel, operatorId }) => {
  const dispatch = useDispatch()
  const inchat = useSelector(state => state.inchat)
  const newConversationId = inchat.parentId ? `${conversationId}_${inchat.parentId}` : conversationId
  const composer = inchat.conversations[newConversationId]?.composer || {}

  const closeSideModal = () => {
    dispatch(inchatActions.onToggleThreads(newConversationId, inchat.parentId))
  }

  return (
    <SidePopup
      onHide={closeSideModal}
      header={lang('inchat_threads')}
      className={'inchat-side-view'}
      overlay={false}
    >
      <div className='side-view-container'>
        <Composer
          conversationId={conversationId}
          channel={channel}
          isThread
          composer={composer}
          parentId={composer.parentId || inchat.parentId}
        />
        <div className='messages-container'>
          <MessageThreads
            key={`thread-${conversationId}`}
            conversationId={conversationId}
            operatorId={operatorId}
            parentId={composer.parentId || inchat.parentId}
          />
        </div>
      </div>
    </SidePopup>
  )
}

export default SideView
